import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { Typography, TypographyVariant } from 'components/core';
import { SectionContainer } from 'modules/dashboard/components';
import { BankAccount as BankAccountType } from 'modules/2023-q3/banking-page/v2/types/bank-account';
import { RemoveBankAccountAction } from 'modules/2023-q3/banking-page/v2/components/bank-accounts/components/bank/components/remove-bank-account-action/remove-bank-account-action';

interface BankAccountProps {
  bankAccount: BankAccountType;
}

export const BankAccountManual: React.FC<BankAccountProps> = ({
  bankAccount,
}) => {
  return (
    <SectionContainer>
      <Box mb={3}>
        <Grid container alignItems="center" justify="space-between">
          <Grid item>
            <Typography
              color="black19"
              variant={TypographyVariant.Header4}
            >{`${bankAccount.Name} (...${bankAccount.Mask})`}</Typography>
          </Grid>
          <Grid item>
            <RemoveBankAccountAction
              accountId={bankAccount.AccountId}
              accountMask={bankAccount.Mask}
              accountName={bankAccount.Name}
            />
          </Grid>
        </Grid>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs>
          <Typography variant={TypographyVariant.Paragraph2}>
            Account Type
          </Typography>

          <Box>
            <Typography
              capitalize
              color="grey1"
              variant={TypographyVariant.Paragraph1}
            >
              {bankAccount.Type}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </SectionContainer>
  );
};
